/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * The Bottlebooks logo.
 * @param {object} props
 * @param {string} [props.className]
 * @param {import('./sizes').IconSize} [props.size]
 */
export default function ChevronDownIcon({ size = 'xlarge', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        height: sizes[size],
        color: '#0071E3',
        verticalAlign: 'middle',
      }}
      viewBox="0 0 140 210"
      {...rest}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero" transform="translate(44 43)">
          <g>
            <path d="M.113 118.599V60.493l.032-.067.002-3.536c0-2.993.005-6 .008-9.006.201-4.71 2.312-8.33 4.36-11.664 2.048-3.342 4.039-6.399 4-9.99V11.214c-.333-.174-.54-.537-.54-1.04V5.863c0-.878.627-1.883 1.433-2.364v-.027c.075-.028.152-.063.23-.098h.003c.001-.007.007-.007.012-.007.005-.007.011-.007.019-.007.004-.009.009-.009.017-.014.006 0 .01 0 .018-.007.005 0 .01 0 .019-.007.005 0 .01 0 .017-.007.006 0 .01-.007.019-.007.004 0 .01-.007.015-.007.005 0 .01-.007.019-.007.004-.007.009-.007.017-.007.006-.008.01-.008.018-.014.005 0 .01 0 .019-.008.004 0 .01 0 .017-.006.005 0 .01-.006.018-.006.005 0 .01-.007.019-.007.005-.007.01-.007.016-.007.004 0 .009-.007.017-.007 2.022-.901 4.045-1.802 6.068-2.7.004-.007.01-.007.018-.014.005 0 .01 0 .017-.007.006 0 .011 0 .019-.01.004 0 .01-.004.015-.004.005 0 .011-.007.019-.007.004 0 .01-.007.017-.007.006-.007.01-.007.018-.007.007-.007.011-.007.019-.014.005 0 .01 0 .017-.007.005 0 .01 0 .019-.007.004 0 .01 0 .018-.009.005 0 .01-.007.016-.007.004 0 .009-.005.017-.005.006 0 .01-.007.018-.007.005-.007.011-.007.019-.007.005-.007.01-.007.017-.014.006 0 .01 0 .019-.009.004 0 .009 0 .017-.005.006 0 .01-.007.018-.007.006 0 .011-.007.016-.007.004 0 .01-.007.018-.007.005 0 .01-.007.019-.007.004-.007.01-.007.017-.007.005-.007.01-.007.018-.015h.013l.004-.007c.076-.033.15-.063.228-.098v.028c.81-.244 1.434.204 1.434 1.082V5.66c0 .502-.209 1.054-.54 1.521v15.021c-.042 3.62 1.95 4.911 3.997 6.425 2.05 1.515 4.162 3.257 4.363 7.787l.001 3.34.081-.006c0 18.463-.05 37.758-.05 56.221C19.218 97.554 4.078 106.821.113 118.6"></path>
            <path d="M38.957 50.72v59.524c-5.636-.122-28.718 3.021-37.295 14.346C5.82 108.24 24.163 99.92 30.157 99.775V50.72h8.8z"></path>
          </g>
          <path d="M51.74 64.679v59.447c-6.515.023-36.146-.03-43.883 0 10.144-7.906 30.395-9.924 36.058-9.413V64.796c3.159-.145 5.893.01 7.826-.117z"></path>
        </g>
      </g>
    </svg>
  );
}
